// extracted by mini-css-extract-plugin
export default {"error":"ErrorPage_error__JbxgF","heading":"ErrorPage_heading__vGEbX","paragraph":"ErrorPage_paragraph__BPSc4","goBack":"ErrorPage_goBack__iRt00"};